/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ThemeType } from "@microsoft/shifts-ui-core";
import { createStore } from "satcheljs";

import { SharedState } from "../SharedState";

/**
 * The store that holds shared info can be used by all experiences.
 */
export const SharedStateStore = createStore<SharedState>("SharedStateStore", {
    locale: "",
    teamId: "",
    theme: ThemeType.Light,
    timeZone: ""
});
